import { useDirectoryMode } from '../../hooks/useDirectoryMode'

function servicesForMode(isEmergency: boolean, isGasSafe: boolean, isWaterSafe: boolean): string[] {
  if (isEmergency) return ['Emergency callouts', 'Burst pipe repair', 'Blocked drains', 'No hot water', 'Out-of-hours repairs', 'Leak emergencies']
  if (isGasSafe)   return ['Boiler repair & service', 'Central heating', 'Gas safety certificates', 'Cooker & hob installation', 'Gas fire service', 'Radiator repairs']
  if (isWaterSafe) return ['Certified water fittings', 'Bathroom installation', 'Tap & toilet replacement', 'Unvented cylinders', 'Leak detection', 'Burst pipe repair']
  return ['Emergency callouts', 'Boiler repair', 'Central heating', 'Burst pipe repair', 'Blocked drains', 'Leak detection', 'Bathroom installation', 'No hot water']
}

export function DirectoryPopularServices() {
  const { isEmergency, isGasSafe, isWaterSafe } = useDirectoryMode()
  const services = servicesForMode(isEmergency, isGasSafe, isWaterSafe)

  return (
    <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-5">
      <p className="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-3">Popular Services</p>
      <div className="flex flex-wrap gap-2">
        {services.map(s => (
          <span key={s} className="text-xs bg-gray-100 hover:bg-gray-200 text-gray-600 px-3 py-1.5 rounded-full transition-colors cursor-default">
            {s}
          </span>
        ))}
      </div>
    </div>
  )
}
